import { backendApi } from "../dynamicBAseQuery";

export const ViewJobPaymentsApi = backendApi.injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
        ReferralCommissionsDetails: builder.mutation({
            query: (args) => ({
                method: 'POST',
                url: "getAllReferralCommissionDetails",
                body: { ...args }
            })
        }),
        referralCommissionApproval:builder.mutation({
            query:(args)=>({
                method:"POST",
                url:"referralCommissionApproval",
                params:args
            })
        }),
        referralPaymentList: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: "referralCommissionPaymentDetails",
                body: { ...args }
            })
        }),
        saveReferralPayment: builder.mutation({
            query: (args) => ({
                method: "POST", 
                url: "saveReferralPaymentRefund",
                body: { ...args }
            })
        }) 
    })
})

export const {
    useReferralCommissionsDetailsMutation,
    useReferralCommissionApprovalMutation,
    useReferralPaymentListMutation,
    useSaveReferralPaymentMutation,
} = ViewJobPaymentsApi
   

